import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const ManagersMessage = () => {
        useEffect(() => {
        document.title = 'Managers Message -  St Peters convent School Faridabad Haryana';  
    }, []); 
    const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Manager");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Manager's Message </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Manager's Message  </h1>
         </div>
     </div>
     <div className="row">
     {data.length > 0 && (
       <div className="clearfix">
          <LazyLoad> <img 
           src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`} 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt={data[0].name || 'Image'}
         /></LazyLoad>
         <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
         <p className="name">
           {data[0].name}<span> {data[0].category} </span>
         </p>
       </div>
     )}

     {data.length === 0  && (
       <div className="clearfix">
          <LazyLoad> <img 
           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg" 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt=""
         /></LazyLoad>
            <p>India is the country which is known as a land of monks sages and saints. We have a reputation for being global spiritual leaders. Since ancient times, our teachers had given spiritual teaching based on scientific logical and universal values that apply to all human beings. But since the last few decades, the aim of education is changing. Education has become a source of only materialistic gains. In this situation of widespread distrust, ambition and demoralization, education can play a crucial role we must evolve our education system in such a way that it may lead towards ultimate and lasting peace. The five prime values of truth, righteousness, peace, compassion and non-violence should be part of every educational system. </p> 
            <p>In St Peter’s Convent School we have transformed our curriculum that caters physical, moral, social, professional and spiritual needs of the children. We are committed to producing enlightened and responsible citizens for our country. Children come here as the unpolished unshaped lump of clay and our teachers polish them and give them wings to fly high and explore the unexplored. The school gives them opportunities and an atmosphere full of positivity, so that they may excel in any field of their choice to the fullest of their potential. </p> 
            <p>With the hope that St Peter's Convent School will serve the society and country with all its resources in the future also as we have done in last past few years I would like to say, new challenges will come, new techniques will be adopted and new faces will join in for this noble work but we will continue to strive on the path of progress because when we strive to become better then what we are, everything around us becomes better too. </p>
            <p className="name">
              SR. ANCY THOMAS <span>  Manager </span>
             </p>
       </div>
     )}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default ManagersMessage
